import React, { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import classes from "./Loading.module.scss";
import { loadingState, loadingText } from "../../states/loadingState";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import { useTheme } from "@mui/material";

interface LoadingProps {
  children: React.ReactNode;
}

const Loading: FC<LoadingProps> = ({ children }) => {
  const isBeingLoaded = useRecoilValue(loadingState);
  const displayText = useRecoilValue(loadingText);
  const user = useRecoilValue(userState);
  const theme = useTheme();
  return (
    <>
      {isBeingLoaded && (
        <section className={classes.section__loading}>
          <CircularProgress sx={{ color: theme.palette.foreColor.main }} />
          <p>{displayText}</p>
        </section>
      )}
      {children}
    </>
  );
};

export default Loading;
